var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    {
      staticClass: "home-footer-info",
      staticStyle: { flex: "none", height: "100%" },
      attrs: { id: "scale" }
    },
    [
      !_vm.editingScale
        ? _c("v-layout", { on: { click: _vm.editScale } }, [
            _c("label", [_vm._v(_vm._s(_vm.$t("Scale")) + " 1:")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.scale))])
          ])
        : _c(
            "v-layout",
            {
              directives: [
                {
                  name: "on-clickaway",
                  rawName: "v-on-clickaway",
                  value: _vm.cancelEdit,
                  expression: "cancelEdit"
                }
              ]
            },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("Scale")) + " 1:")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.scale,
                    expression: "scale"
                  }
                ],
                staticStyle: { width: "60px", "background-color": "#e8e8e8" },
                attrs: { type: "number", min: 0, spellcheck: "false" },
                domProps: { value: _vm.scale },
                on: {
                  keyup: [
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      ) {
                        return null
                      }
                      return _vm.saveScale(_vm.scale)
                    },
                    function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "esc", 27, $event.key, [
                          "Esc",
                          "Escape"
                        ])
                      ) {
                        return null
                      }
                      return _vm.cancelEdit.apply(null, arguments)
                    }
                  ],
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.scale = $event.target.value
                  }
                }
              })
            ]
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5feef7f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5feef7f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Footer/Scale.vue
// module id = null
// module chunks = 